function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Lib Imports
import React, { memo, forwardRef, useMemo } from 'react';
import PropTypes from 'prop-types';
// import { TableRow, TableCell, Text } from "grommet";
import { Cell } from './Cell';
import { classes } from '../utils';
export const Row = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(({
  cells,
  TrComponent,
  TdComponent,
  onClick,
  row,
  ...rest
}, ref) => {
  const {
    rowBackground,
    rowColor
  } = row?.original ?? {};
  const {
    style = {}
  } = rest ?? {};
  const rowStyle = useMemo(() => {
    return {
      ...style,
      backgroundColor: rowBackground,
      color: rowColor
    };
  }, [rowBackground, rowColor, style]);
  return /*#__PURE__*/React.createElement(TrComponent, _extends({}, rest, {
    row: row,
    className: classes(row.isSelected && '-selected', typeof onClick === 'function' && 'clickable-row'),
    style: rowStyle,
    onClick: () => typeof onClick === 'function' && onClick(row),
    ref: ref
  }), cells.map((cell, index) => {
    return /*#__PURE__*/React.createElement(Cell, _extends({
      key: index,
      TdComponent: TdComponent,
      cell: cell
    }, cell.getCellProps()));
  }));
}));
Row.displayName = 'Row';
Row.propTypes = {
  // add your proptypes here
  cells: PropTypes.array.isRequired,
  TrComponent: PropTypes.any,
  TdComponent: PropTypes.any,
  onClick: PropTypes.func
};

// export React.memo(Row);